export const RESOURCE_PASSWORD_UPDATED = "accessCode/added"
export const RESOURCE_PASSWORD_DELETED = "accessCode/deleted"